import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import moment from 'moment'

@Component({
  selector: 'mmx-timeslot-recommendation',
  templateUrl: './time-slot-recommendation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TimeSlotRecommendationComponent {
  @Input()
  public timeSlot: moment.Moment | undefined

  @Input()
  public disabled = false

  @Input()
  public label = ''

  @Input()
  public icon = ''

  @Output()
  public add = new EventEmitter<moment.Moment>()

  public get formattedTimeSlot(): string {
    return !!this.timeSlot ? this.timeSlot.format('MMMM Do h:mm a') : ''
  }
}
